import { render, staticRenderFns } from "./DatosDespacho.vue?vue&type=template&id=2a9ccd08&scoped=true"
import script from "./DatosDespacho.vue?vue&type=script&lang=js"
export * from "./DatosDespacho.vue?vue&type=script&lang=js"
import style0 from "./DatosDespacho.vue?vue&type=style&index=0&id=2a9ccd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ccd08",
  null
  
)

export default component.exports